<template>
  <transition name="fade">
    <div class="modal-manager" v-if="nowState !== null">
      <component :is="nowComponent" :param="param"/>
    </div>
  </transition>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'ModalManager',
  props: {
    modalList: {
      type: Array,
    },
  },
  methods: {
    changeToComponent(state, param) {
      this.nowState = state;
      this.param = param;
    },

    clearComponent() {
      this.nowState = null;
    },

    findDefaultComponent() {
      let result = null;

      this.modalList.forEach((modal) => {
        if (modal.default === true) result = modal.component;
      });

      return result;
    },

    objectization() {
      const result = {};
      this.modalList.forEach((modal) => {
        result[modal.name] = modal.component;
      });

      return result;
    },
  },
  computed: {
    nowComponent() {
      return this.nowState;
    },
  },
  created() {
    const EventBus = new Vue();

    EventBus.changeToComponent = this.changeToComponent;
    EventBus.clearComponent = this.clearComponent;

    Object.defineProperties(Vue.prototype, {
      $modal: {
        get: () => EventBus,
        configurable: false,
      },
    });

    Object.defineProperties(Vue.prototype.$modal, {
      modalType: {
        get: () => Object.freeze(this.stateList),
        configurable: false,
      },
    });
  },
  data() {
    return {
      param: null,
      stateList: this.objectization(),
      nowState: this.findDefaultComponent(),
    };
  },
};
</script>

<style lang="scss" scoped>
.modal-manager {
  position: fixed;
  left: 0;
  top: 0;

  width: 100vw;
  height: 100vh;

  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;

  z-index: 1500;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s, transform 0.2s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
</style>



// WEBPACK FOOTER //
// src/modules/modal-manager/ModalManager.vue